// @flow

import React from 'react';
import {Row} from './data-table-row';

import type {Element, StatelessFunctionalComponent as FC} from 'react';

type THeadProps = {|
    children: Element<typeof Row> | Array<Element<typeof Row>>,
|};

export const THead: FC<THeadProps> = (props: THeadProps) => <div className="data-table__thead">{props.children}</div>;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./data-table-row");
